import React from 'react';

import { AuthProvider } from './Auth';
import { ResizeProvider } from './Resize';
import { BulkEmailProvider } from './useBulkEmailDispatch';
import { HelpNotificationsProvider } from './HelpNotifications';

const AppProvider: React.FC = ({ children }) => (
  <ResizeProvider>
    <AuthProvider>
      <BulkEmailProvider>
        <HelpNotificationsProvider>{children}</HelpNotificationsProvider>
      </BulkEmailProvider>
    </AuthProvider>
  </ResizeProvider>
);

export default AppProvider;
